import { render, staticRenderFns } from "./FeaturePage.vue?vue&type=template&id=3b3dd4f8"
import script from "./FeaturePage.vue?vue&type=script&lang=js"
export * from "./FeaturePage.vue?vue&type=script&lang=js"
import style0 from "./FeaturePage.vue?vue&type=style&index=0&id=3b3dd4f8&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports